import styled from 'styled-components'

const ServiceTitle = styled.h2`
  color: #304760;
  font-size: 36px;
  font-weight: 300;
  margin-top: 0;
  margin-bottom: 2em;
  text-align: center;

  /* Extra Small Devices, Phones */ 
  @media only screen and (max-width : 480px){
    font-size: 1.5em;
  }
`
export default ServiceTitle



// WEBPACK FOOTER //
// ./src/components/Services/ServiceTitle.js